export default __webpack_public_path__ + "img/17.asset.014056ea.jpeg";